"use strict";
// @ts-ignore
try {
    self['workbox:navigation-preload:6.2.4'] && _();
}
catch (e) { }
